module.exports = __webpack_public_path__ + "static/media/recycle.f6428f45.svg";